import React,{useEffect, useState} from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

function PrintLabelComponent({barcodeList}) {
    const [dialogStatus, setDialogStatus] = useState(false);
    useEffect(()=>{
        setDialogStatus(true)
    },[barcodeList])
    return (
        <div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="sm"
            >
                <DialogTitle>Batch Id : {barcodeList.batchDetails.id} - ({barcodeList.data.length} / {barcodeList.batchDetails.count})  </DialogTitle>
                <DialogContent>
                    <div className='row mt-2'>
                        {barcodeList.data.map(barcode=>
                            <div  key={barcode.id} className='col-md-6'>
                                <span className='barcode'>*{barcode.id}*</span>
                            </div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-outline-primary" >Print</button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default PrintLabelComponent